// Our main CSS
import '../css/app.css'
import MainNavigation from './modules/site-navigation'
import Accordion from './modules/accordion'
import Search from './modules/search'
import RegionSelect from './modules/region-select'
import DistrictSelect from './modules/district-select-menu'
import Geolocation from './modules/geolocation/index'
Geolocation()
MainNavigation()
Accordion()
Search()
RegionSelect()
DistrictSelect()

// Esc i ett ifyllt sökfält tömmer bara fältet (webbläsarens standard) utan
// att stänga lådan. I ett tomt fält får Esc nå dokumentet och stänga lådan,
// så att fokus går tillbaka till öppningsknappen (issue #346). Tidigare
// stoppades händelsen alltid och fältet tappade fokus till body.
const search_inputs = document.querySelectorAll('input[type=search]')
if (search_inputs && search_inputs !== null) {
  search_inputs.forEach((input) => {
    input.addEventListener('keydown', (e) => {
      const evt = e as KeyboardEvent
      const input = evt.target as HTMLInputElement
      if (evt.key === 'Escape' && input.value !== '') {
        evt.stopPropagation()
      }
    })
  })
}

const accordion_group = document.querySelectorAll('[data-ui-accordion-group]')

if (accordion_group && accordion_group.length) {
  accordion_group.forEach((el) => {
    import('./modules/accordion-group')
      .then((module) => {
        module.default(el as HTMLElement)
      })
      .catch((err) => {
        console.log(err)
      })
  })
}

// Videofasad för YouTube (issue #354)
const youtube_facades = document.querySelectorAll('[data-youtube-facade]')
if (youtube_facades.length) {
  import('./modules/video-facade')
    .then((module) => {
      youtube_facades.forEach((el) => module.default(el as HTMLElement))
    })
    .catch((err) => {
      console.log(err)
    })
}

// Långa ord i rubriker krymps i stället för att brytas (issue #394)
const long_word_headings = document.querySelectorAll<HTMLElement>(
  '.hero-heading > span, .article-card h3, .EventCard-title, .CourseCard-title'
)
if (long_word_headings.length) {
  import('./modules/fit-long-words')
    .then((module) => {
      module.default([...long_word_headings])
    })
    .catch((err) => {
      console.log(err)
    })
}

const article_sliders = document.querySelectorAll('[data-article-slider]')

if (article_sliders && article_sliders.length) {
  article_sliders.forEach((el) => {
    import('./modules/article-slider')
      .then((module) => {
        module.default(el as HTMLElement)
      })
      .catch((err) => {
        console.log(err)
      })
  })
}

// "Hämta" gör en hel sidladdning — spara scrolläget vid klicket och
// återställ det exakt när den nya sidan laddats. Återställ både direkt
// och efter window.load, så att sena layoutskiften inte flyttar sidan.
const fetchPersonButtons = document.querySelectorAll(
  '[name=fetch_person], [name=other_fetch_person]'
)
fetchPersonButtons.forEach((btn) => {
  btn.addEventListener('click', () => {
    sessionStorage.setItem('anmalan_scroll_y', String(window.scrollY))
  })
})
if (fetchPersonButtons.length) {
  const savedScrollY = sessionStorage.getItem('anmalan_scroll_y')
  if (savedScrollY !== null) {
    sessionStorage.removeItem('anmalan_scroll_y')
    const y = parseInt(savedScrollY, 10)
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'
    }
    window.scrollTo(0, y)
    window.addEventListener(
      'load',
      () => requestAnimationFrame(() => window.scrollTo(0, y)),
      { once: true }
    )
  }
}

const personNummerInputs = document.querySelectorAll('[name=personnummer]')

function handlePersonnummerChange(input) {
  input.setCustomValidity('')

  const target = input.dataset?.target
  const targetElement = document.querySelector(target)

  if (!targetElement) {
    return
  }

  const value = input.value
  const personnummer = value.replace(/\D/g, '')
  const personnummerLength = personnummer.length

  if (personnummerLength >= 8) {
    const year = personnummer.substr(0, 4)
    const month = personnummer.substr(4, 2)
    var day = personnummer.substr(6, 2)
    if (day > 60 && day <= 91) {
      day -= 60
    }

    let now = new Date()
    now.setHours(0, 0, 0, 0)
    const date = new Date(`${year}-${month}-${day} 00:00:01`)
    // Calculate age depending on date
    const ageDifMs = now.getTime() - date.getTime()
    const ageYear = Math.abs(new Date(ageDifMs).getUTCFullYear() - 1970)

    // remove classes hidden and block
    targetElement.classList.remove('hidden')
    targetElement.classList.remove('block')
    targetElement.classList.add(ageYear >= 18 ? 'hidden' : 'block')

    // When the målsman section is hidden its personnummer field must never
    // block the form (an invalid but invisible field is unsubmittable).
    if (ageYear >= 18) {
      document
        .querySelectorAll('[name=other_personnummer]')
        .forEach((other: HTMLInputElement) => other.setCustomValidity(''))
      document
        .querySelector('#other_person_age_warning')
        ?.classList.add('hidden')
    }
  } else {
    targetElement.classList.add('hidden')
    targetElement.classList.remove('block')
    input.setCustomValidity('Ogiltigt personnummer')
  }
}

personNummerInputs.forEach((input) => {
  input.onchange = function () {
    handlePersonnummerChange(this)
  }

  handlePersonnummerChange(input)
})

const otherpersonNummerInputs = document.querySelectorAll(
  '[name=other_personnummer]'
)

function handleOtherPersonnummerChange(input) {
  input.setCustomValidity('')

  const target = input.dataset?.target
  const targetElement = document.querySelector(target)

  if (!targetElement) {
    return
  }

  const value = input.value
  const personnummer = value.replace(/\D/g, '')
  const personnummerLength = personnummer.length

  if (personnummerLength >= 8) {
    const year = personnummer.substr(0, 4)
    const month = personnummer.substr(4, 2)
    const day = personnummer.substr(6, 2)

    let now = new Date()
    now.setHours(0, 0, 0, 0)
    const date = new Date(`${year}-${month}-${day} 00:00:01`)
    // Calculate age depending on date
    const ageDifMs = now.getTime() - date.getTime()
    const ageYear = Math.floor((new Date() - date.getTime()) / 3.15576e10)
    // Math.abs(new Date(ageDifMs).getUTCFullYear() - 1970);

    // remove classes hidden and block
    targetElement.classList.remove('hidden')
    targetElement.classList.remove('block')

    const warning = document.querySelector('#other_person_age_warning')
    if (ageYear < 18) {
      // An under-18 payer must get an explicit warning, not just a
      // silently hidden fetch button (issue #54).
      targetElement.classList.add('hidden')
      warning?.classList.remove('hidden')
      input.setCustomValidity('Målsman/annan betalare måste ha fyllt 18 år')
    } else {
      warning?.classList.add('hidden')
      input.setCustomValidity('')
    }
  } else {
    targetElement.classList.add('hidden')
    targetElement.classList.remove('block')
    document
      .querySelector('#other_person_age_warning')
      ?.classList.add('hidden')
  }
}

otherpersonNummerInputs.forEach((input) => {
  input.onchange = function () {
    handleOtherPersonnummerChange(this)
  }

  handleOtherPersonnummerChange(input)
})

const general_popup = document.querySelector('#GeneralPopup')
if (general_popup) {
  import('./modules/general-popup-dialog')
    .then((module) => {
      module.default(general_popup as HTMLDialogElement)
    })
    .catch((err) => {
      console.log(err)
    })
}

const expanding_content_blocks = document.querySelectorAll<HTMLElement>(
  '[data-ui-expandable-content]'
)
if (expanding_content_blocks?.length) {
  import('./modules/expandable-content').then(
    ({ default: handleExpandableContent }) => {
      handleExpandableContent(expanding_content_blocks)
    }
  )
}

const CourseRegistrationForm = document.querySelector(
  '.CourseRegistration form'
)
if (CourseRegistrationForm) {
  import('./modules/course-registration-form')
    .then((module) => {
      module.default(CourseRegistrationForm as HTMLFormElement)
    })
    .catch((err) => {
      console.log(err)
    })
}

const customSelects = document.querySelectorAll('.js-custom-select')

if (customSelects && customSelects.length) {
  customSelects.forEach((el: any) => {
    const customDiv = el.nextElementSibling
    const textEl = el.nextElementSibling?.querySelector(
      '.js-custom-select__text'
    )

    customDiv.addEventListener('click', () => {
      el.focus()
      el.click()
    })

    el.addEventListener('change', (e: InputEvent) => {
      const selectedOption = el.options[el.selectedIndex]

      if (selectedOption.value) {
        textEl.textContent = selectedOption.textContent
        textEl.classList.remove('text-gray-400')
      } else {
        textEl.textContent = 'Välj'
        textEl.classList.add('text-gray-400')
      }
    })

    if (el.value) {
      const selectedOption = el.options[el.selectedIndex]
      textEl.textContent = selectedOption.textContent
      textEl.classList.remove('text-gray-400')
    }
  })
}
